// @flow

export function navigateTo (url: string, state: Object = {}): void {
  window.history.pushState(state, '', url)
}
